import TimingDate from '../timing/timing-date.vue';

export default TimingDate;



// WEBPACK FOOTER //
// ./src/components/timing-date/index.js